import React from "react";

const SecurityBlock = () => {
  return (
    <div className="bg-gray-800 py-10 border">
      <div className="container mx-auto text-center ">
        <h1 className="text-3xl font-semibold text-white mb-4">
          Verilerin Güvende Bloğu
        </h1>
        <p className="text-gray-400 text-lg">
          Kişisel bilgilerinizi güvenli bir şekilde saklıyoruz ve gizliliğinizi
          önemsiyoruz.
        </p>
      </div>
    </div>
  );
};

export default SecurityBlock;
